import type { GroupItemVO, RangeVO } from "@/api"
import { CaretDownOutlined } from "@ant-design/icons"
import { useCreation, useSetState } from "ahooks-v2"
import { Button } from "antd"
import classNames from "classnames"
import type { ForwardRefRenderFunction } from "react"
import { forwardRef, useCallback, useImperativeHandle, useRef } from "react"
import "./index.scss"
// ==============================================
import Popover from "../../Popover"
import RangeComponent from "../RangeComponent"
// ==============================================
interface stateVO {
  visible: boolean
}
interface RangePopoverProps {
  tabKey: string
  data: RangeVO[]
  group: GroupItemVO[]
  // 组件显隐
  visible?: boolean
  // 是否禁用
  disabled?: boolean
  // class
  className?: string
  // 组件名称
  title?: string
  // 固定名称
  fixedName?: string
  // 传递数据到父组件
  passData?: (type: string, data: any) => void
  // 弹出框visible变化
  onDropdownVisibleChange?: (visible: boolean) => void
}
const RangePopover: ForwardRefRenderFunction<any, RangePopoverProps> = (
  {
    tabKey,
    data,
    group,
    visible: moduleVisible = true,
    disabled = false,
    className = "",
    title = "",
    fixedName = "",
    passData,
    onDropdownVisibleChange,
  },
  ref: any,
) => {
  const RangeComponentRef = useRef<any>()
  const [state, set] = useSetState<stateVO>({
    visible: false,
  })
  const { visible } = state

  // 显示名称
  const showName = useCreation(() => {
    return data?.map((item) => item.showName)?.join("/") || ""
  }, [data])

  // 控制Popover
  const togglePopover = useCallback(
    (visible: boolean) => {
      set({
        visible,
      })
      // 弹出框visible变化
      onDropdownVisibleChange && onDropdownVisibleChange(visible)
    },
    [set, onDropdownVisibleChange],
  )

  // 重置为默认数据
  const resetDefaultData = useCallback(() => {
    RangeComponentRef.current?.resetDefaultData()
  }, [])

  // 重置为上一次的数据
  const resetBeforeData = useCallback(() => {
    RangeComponentRef.current?.resetBeforeData()
  }, [])

  // 传递方法到父组件
  useImperativeHandle(ref, () => ({
    resetDefaultData,
    resetBeforeData,
    togglePopover,
  }))

  return (
    <Popover
      key={`${tabKey}Popover`}
      className="range-popover"
      visible={visible}
      content={
        <RangeComponent
          ref={RangeComponentRef}
          key={tabKey}
          componentKey={tabKey}
          group={group}
          visible={visible}
          data={data}
          passData={passData}
          onClose={() => togglePopover(false)}
        />
      }
    >
      <Button
        type="primary"
        className={classNames("theme-filter-condition-btn", className, {
          none: !moduleVisible,
        })}
        disabled={disabled}
        onClick={() => togglePopover(true)}
      >
        {fixedName || `${title}${title ? "：" : ""}${showName}`}
        <CaretDownOutlined style={{ fontSize: "1rem" }} />
      </Button>
    </Popover>
  )
}

export default forwardRef(RangePopover)
